export default (props) => {
	const listItems = props?.alumniImages.map((item) => ({
		url: item.image.image,
		alt: item.image.altTag,
	}));
	const labelConfig = { text: props?.label };
	return { listItems, labelConfig };
};
